import React from 'react';

export const PDFIcon = () => {
  return (
    <svg
      width="22"
      height="30"
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 4C0.75 2.20508 2.20508 0.75 4 0.75H20C20.1212 0.75 20.2375 0.798159 20.3232 0.883885L31.1161 11.6768C31.2018 11.7625 31.25 11.8788 31.25 12V36C31.25 37.7949 29.7949 39.25 28 39.25H4C2.20507 39.25 0.75 37.7949 0.75 36V4Z"
        stroke="#D0D5DD"
        strokeWidth="1.5"
      />
      <path
        d="M20 0.5V8C20 10.2091 21.7909 12 24 12H31.5"
        stroke="#D0D5DD"
        strokeWidth="1.5"
      />
      <path
        d="M21.7088 25.3438C20.586 25.3438 19.1808 25.5396 18.7211 25.6085C16.8184 23.6216 16.277 22.4922 16.1553 22.191C16.3203 21.7671 16.8944 20.1564 16.976 18.0878C17.0162 17.0521 16.7975 16.2782 16.3256 15.7876C15.8545 15.2979 15.2843 15.2598 15.1208 15.2598C14.5475 15.2598 13.5857 15.5497 13.5857 17.4911C13.5857 19.1756 14.3711 20.9631 14.5882 21.4249C13.4443 24.7554 12.2163 27.0353 11.9556 27.5042C7.35942 29.2347 7 30.9079 7 31.3821C7 32.2342 7.60689 32.743 8.62343 32.743C11.0932 32.743 13.347 28.5965 13.7197 27.8765C15.4738 27.1776 17.8216 26.7446 18.4184 26.6413C20.1304 28.2721 22.1104 28.7073 22.9326 28.7073C23.5512 28.7073 24.9999 28.7073 24.9999 27.2177C25 25.8345 23.2271 25.3438 21.7088 25.3438ZM21.5898 26.3216C22.9238 26.3216 23.2764 26.7628 23.2764 26.9961C23.2764 27.1424 23.2208 27.62 22.5058 27.62C21.8646 27.62 20.7575 27.2494 19.6683 26.4454C20.1225 26.3857 20.7947 26.3216 21.5898 26.3216ZM15.0508 16.2076C15.1724 16.2076 15.2525 16.2467 15.3185 16.3383C15.7022 16.8706 15.3928 18.6103 15.0163 19.9716C14.6528 18.8043 14.38 17.0133 14.7638 16.3831C14.8388 16.2602 14.9246 16.2076 15.0508 16.2076ZM14.4029 26.6275C14.8859 25.6517 15.4272 24.2297 15.722 23.4255C16.3121 24.4131 17.1057 25.3301 17.5647 25.8272C16.1356 26.1285 15.0543 26.4295 14.4029 26.6275ZM7.9594 31.5123C7.92758 31.4745 7.92288 31.395 7.94686 31.2994C7.99714 31.0993 8.38141 30.1072 11.1608 28.8639C10.7628 29.4907 10.1407 30.3864 9.45717 31.0556C8.97605 31.5059 8.60142 31.7343 8.34367 31.7343C8.25146 31.7343 8.12442 31.7092 7.9594 31.5123Z"
        fill="#D92D20"
      />
    </svg>
  );
};
